module.exports = __webpack_public_path__ + "img/MzGW.705f79ca.svg";